$.fn.HomeSlider = function() {
  let self = $(this).BlockElement()

  self.el = {
    title: self.find('.home-slider__title'),
    keywords: self.find('.home-slider__keywords'),
    arrow: self.find('.home-slider__down-arrow'),
    article: self.find('.home-slider__article'),
    link: self.find('.home-slider__article-link'),
  }

  self.previous_slide = undefined
  self.current_slide = self.find('.home-slide:first-child')
  self.zIndex = 1

  if (self.data('home-slider')) {
    return self.data('home-slider')
  }

  self.play_intro = function() {
    setTimeout(function() {
      self.el.title.addClass('--visible')
    }, 500)
    setTimeout(function() {
      self.el.arrow.addClass('--visible')
      self.el.article.addClass('--visible')
      self.el.link.addClass('--visible')
      self.el.keywords.addClass('--visible')
      self.find('.home-slider__keywords .home-slider-keyword').addClass('--visible')
      if (self.find('.home-slide').length > 1) {
        setTimeout(self.play_next_slide, 2000)
      }
    }, 1250)
  }

  self.get_next_slide = function() {
    self.current_slide.addClass('--previous')
    self.current_slide = self.current_slide.next()
    if (!self.current_slide.length) {
      self.current_slide = self.find('.home-slide:first-child')
    }
    self.current_slide.css('z-index', ++self.zIndex)
  }

  self.play_next_slide = function() {
    self.el.link.removeClass('--visible')
    self.previous_slide = self.current_slide
    self.find('.home-slider__keywords .home-slider-keyword').addClass('--hidden')
    setTimeout(function() {
      self.get_next_slide()
      self.find('.home-slider__keywords .home-slider-keyword:first-child').replaceWith(self.current_slide.find('.home-slider-keyword:first-child').clone())
      self.find('.home-slider__keywords .home-slider-keyword:last-child').replaceWith(self.current_slide.find('.home-slider-keyword:last-child').clone())
      self.el.link = self.current_slide.find('.home-slide__article-link').clone().removeClass('home-slide__article-link').addClass('home-slider__article-link')
      self.el.link.find('.home-slide__link').removeClass('home-slide__link').addClass('home-slider__link')
      self.find('.home-slider__article-link').replaceWith(self.el.link)
      setTimeout(function() {
        self.find('.home-slider__keywords .home-slider-keyword:first-child').addClass('--visible')
        self.find('.home-slider__keywords .home-slider-keyword:last-child').addClass('--visible ')
        self.el.link.addClass('--visible ')
        self.current_slide.attr('aria-hidden', 'false')
        self.previous_slide.attr('aria-hidden', 'true')
        setTimeout(function() {
          self.previous_slide.removeClass('--previous')
        }, 750)
        setTimeout(function() {
          self.play_next_slide()
        }, 2000)
      }, 150)
    }, 750)
  }

  return function() {
    self.play_intro()
    self.data('home-slider', self)
    return self
  }()
}
